import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useAppendBodyClasses } from "@circle-react/hooks/useAppendBodyClasses";
import { useHideCommunitySwitcher } from "@circle-react/hooks/useHideCommunitySwitcher";

export interface EmptyLayoutProps {
  bodyClassNames?: string;
  children: React.ReactNode;
}

export const EmptyLayout = ({
  children,
  bodyClassNames = "",
}: EmptyLayoutProps) => {
  useAppendBodyClasses(classNames(bodyClassNames, "trix-v2"));
  useHideCommunitySwitcher();

  return <div className="standard-layout-v2">{children}</div>;
};
